import React from 'react';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

const HTMLCellRenderer: TResponsiveTableCellRenderer<{ html: string }> =
  React.forwardRef<
    HTMLTableCellElement,
    TResponsiveTableCellRendererProps<{ html: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => (
      <td
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...props}
        {...cell}
        {...(rendererProps?.html
          ? {
              dangerouslySetInnerHTML: {
                __html: rendererProps.html.replaceAll(
                  /<TOK(\d+)/g,
                  '&lt;TOK$1',
                ),
              },
            }
          : { children })}
      />
    ),
  );

export default HTMLCellRenderer;
